export default __webpack_public_path__ + "src/images/btn_right_green-788ca3.png";